import React from 'react'
import { Text, View } from 'react-native'
import { useThemeValue } from '../ThemeContext'
import { baseFont, HEADER_HEIGHT, sharedStyles } from '../utils/ui'
import {
  EnterpriseSection,
  FeaturesSection,
  Hero,
  HomeInsight,
  HomeNarrative,
  MobileAppPreview,
  PricingSection,
  ProductDemo,
} from '../components/HomeSections'
import { LinearGradient } from 'expo-linear-gradient'
import { Container, Section } from '../components/ui'

export function HomePage({ onCtaClick }: { onCtaClick: (plan?: string) => void }) {
  const { theme } = useThemeValue()

  return (
    <View>
      <Section background={theme.colors.background} paddingTop={HEADER_HEIGHT + 44} paddingBottom={40} fullHeight>
        <LinearGradient
          colors={theme.dark ? ['rgba(129,140,248,0.16)', 'rgba(192,132,252,0.08)', 'transparent'] : ['rgba(79,70,229,0.16)', 'rgba(147,51,234,0.08)', 'transparent']}
          start={{ x: 0.15, y: 0 }}
          end={{ x: 0.9, y: 0.7 }}
          style={sharedStyles.absoluteFill}
        />
        <LinearGradient
          colors={theme.dark ? ['rgba(255,255,255,0.04)', 'transparent'] : ['rgba(255,255,255,0.75)', 'transparent']}
          start={{ x: 0.5, y: 0 }}
          end={{ x: 0.5, y: 1 }}
          style={sharedStyles.absoluteFill}
        />
        <Container>
          <Hero onCtaClick={() => onCtaClick()} />
        </Container>
      </Section>
      <ProductDemo />
      <MobileAppPreview onCtaClick={() => onCtaClick()} />
      <HomeNarrative />
      <FeaturesSection anchorId="features" />
      <EnterpriseSection anchorId="pillars" />
      <HomeInsight />
      <PricingSection onCtaClick={onCtaClick} anchorId="pricing" />
    </View>
  )
}
